module.exports = __webpack_public_path__ + "static/media/cms_logo.07719612.jpg";